
import React from 'react';
import { Text } from 'office-ui-fabric-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { FontIcon } from "office-ui-fabric-react";
import {
    PRICELIST_TYPE_CUSTOM, PRICELIST_TYPE_DEFAULT, PRICELIST_TYPE_EDIT_DEFAULT, PRICELIST_TYPE_FILE
} from '../../reducers/project';

const classNames = mergeStyleSets({
    label: {
        borderBottom: '1px solid #000000'
    },

    typeTextBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },

    icon: {
        marginRight: '1em'
    }
})


const SelectPricelistTypeDisabled = ({
    onChangeClick,
    pricelistType
}) => {

    const getPricelistTypeText = () => {
        switch (pricelistType) {
            case PRICELIST_TYPE_CUSTOM:
                return 'Tvorba vlastního ceníku';
            case PRICELIST_TYPE_DEFAULT:
                return 'Používá se výchozí ceník';
            case PRICELIST_TYPE_EDIT_DEFAULT:
                return 'Úprava výchozího ceníku';
            case PRICELIST_TYPE_FILE:
                return 'Načtení ceníku ze souboru';
            default:
                return '';
        }
    }

    const handleChangeClick = () => {
        if (onChangeClick) {
            onChangeClick();
        }
    }

    return (
        <Stack>
            <Stack.Item>
                <h3 className={classNames.label}>Způsob zadání ceníku prací a materiálů</h3>
            </Stack.Item>
            <Stack.Item className={classNames.typeTextBox}>
                <Stack.Item>
                    <FontIcon className={classNames.icon} iconName="GripperDotsVertical"></FontIcon>
                    <Text variant={'medium'}>{getPricelistTypeText()}</Text>
                </Stack.Item>
                <DefaultButton iconProps={{iconName: "BranchCompare"}} onClick={handleChangeClick}>Změnit ceník</DefaultButton>
            </Stack.Item>
        </Stack>
    );
}

export default SelectPricelistTypeDisabled;
